import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { type EmblaCarouselType, EmblaOptionsType } from 'embla-carousel'
import { qsaRequired, qsRequired } from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'

const addDotBtnsAndClickHandlers = (
	emblaApi: EmblaCarouselType,
	dotEls: NodeListOf<HTMLButtonElement>
): (() => void) => {
	let dotNodes: HTMLElement[] = []

	const addDotBtnsWithClickHandlers = (): void => {
		dotNodes = Array.from(dotEls)
		dotNodes.forEach((dotNode, index) => {
			dotNode.addEventListener(
				'click',
				(_: Event) => {
					emblaApi.scrollTo(index)
				},
				false
			)
		})
	}

	const toggleDotBtnsActive = (): void => {
		const previous = emblaApi.previousScrollSnap()
		const selected = emblaApi.selectedScrollSnap()
		dotNodes[previous].classList.remove('embla__dot--selected')
		dotNodes[selected].classList.add('embla__dot--selected')
	}

	emblaApi
		.on('init', addDotBtnsWithClickHandlers)
		.on('reInit', addDotBtnsWithClickHandlers)
		.on('init', toggleDotBtnsActive)
		.on('reInit', toggleDotBtnsActive)
		.on('select', toggleDotBtnsActive)

	return (): void => {
		// TODO: Remove event listeners
	}
}

export class TestimonialsSlider extends UcoastEl {
	static htmlSelector = 'testimonials-slider'
	autoRotate: boolean
	constructor() {
		super()
		this.autoRotate = this.hasAttribute('data-embla-auto')
		const OPTIONS: EmblaOptionsType = {
			inViewThreshold: 1,
			containScroll: 'trimSnaps',
			align: 'start',
			duration: 0,
			dragThreshold: 100,
		}

		const viewportNode = qsRequired('.embla__viewport', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
			AutoHeight(),
		])

		const dots = qsaRequired<HTMLButtonElement>('[data-embla-dot]', this)

		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
			emblaApi,
			dots
		)

		emblaApi.on('destroy', removeDotBtnsAndClickHandlers)
	}
}
